// Canonical labels from the backend HighLevelCategory enum.
export const QNA_AREAS = [
  "Revenue",
  "Cost of Sales",
  "Direct Employee Cost",
  "Employee Costs",
  "Operating Expenses",
  "Central Overheads",
  "Other Income",
  "Depreciation",
  "Interest",
  "Tax Expense",
  "Cash and Cash Equivalents",
  "Trade Debtors",
  "Inventory",
  "Prepayments",
  "Other Debtors",
  "Other Current Assets",
  "Fixed Assets",
  "Intangible Assets",
  "Goodwill",
  "WIP",
  "Trade Creditors",
  "Accruals",
  "Other Creditors",
  "Other Current Liabilities",
  "Debt",
  "Shareholder Loans",
  "Related Party",
  "GST/VAT",
  "Payroll-Related Taxes",
  "Income Tax",
  "Deferred Tax",
  "Retained Earnings",
  "Current Year Profit",
  "Revaluation Reserve",
  "Foreign Currency Translation Reserve",
  "Other Reserves",
  "Dividends Declared",
  "Treasury Shares",
  "Share Capital",
] as const;

export type QnaArea = (typeof QNA_AREAS)[number];
